import { render, staticRenderFns } from "./AdminProductTrainingDialog.vue?vue&type=template&id=227535c6"
import script from "./AdminProductTrainingDialog.vue?vue&type=script&lang=js"
export * from "./AdminProductTrainingDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminProductTrainingDialog.vue?vue&type=style&index=0&id=227535c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports